import React, { useContext } from 'react';
import { Row } from 'react-bootstrap';

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import OrderContext from '../OrderContext';
import PostSubmissionBanner from './submit/PostSubmissionBanner';
import { IconWrapper } from '../../../common/IconWrapper';
import PostSubmissionMinimumOrderQuantity from './moq/PostSubmissionMinimumOrderQuantity';

export default function OrderStatusBanner({ showPostSubmission }) {
    const { orderHeader, basket } = useContext(OrderContext);

    return (
        <>
            {orderHeader.orderStatus === 'DELETED' && (
                <Row className={'order-status-information flex'}>
                    <div className={'icon'}>
                        <IconWrapper icon={faInfoCircle} />
                    </div>
                    <div className={'text'}>
                        <span className={'top-row'}>Order deleted</span>
                        <br />
                        Your order has been deleted
                    </div>
                </Row>
            )}

            {(orderHeader.orderStatus === 'INVOICED' || orderHeader.orderStatus === 'DELIVERED') && (
                <Row className={'order-status-information flex'}>
                    <div className={'icon'}>
                        <IconWrapper icon={faInfoCircle} />
                    </div>
                    <div className={'text'}>
                        <span className={'top-row'}>Order complete</span>
                        <br />
                        Your delivery note {orderHeader.orderStatus === 'INVOICED'
                            ? 'and invoice are'
                            : 'is'}{' '}
                        available.
                    </div>
                </Row>
            )}

            {orderHeader.orderStatus === 'OPEN' && basket.rejected.length > 0 && (
                <Row className={'order-status-information flex'}>
                    <div className={'icon'}>
                        <IconWrapper icon={faInfoCircle} />
                    </div>
                    <div className={'text'}>
                        <span className={'top-row'}>There are issues with your order</span>
                        <br />
                        You can still submit but you may not receive all your products; please review the
                        sections below.
                    </div>
                </Row>
            )}

            {showPostSubmission && (
                <>
                    <Row className={'order-status-information flex'}>
                        <div className={'icon'}>
                            <IconWrapper icon={faInfoCircle} />
                        </div>
                        <div className={'text'}>
                            <span className={'top-row'}>Order submitted successfully</span>
                            <br />
                            Your order has been received and will now be processed.
                        </div>
                    </Row>
                    <PostSubmissionMinimumOrderQuantity />
                    <Row>
                        <PostSubmissionBanner />
                    </Row>
                </>
            )}
        </>
    );
}
